/**
 * Copyright (c) 2024 Securisea, Inc.
 * All rights reserved.
 *
 * This is unpublished, propriety, internal
 * source code of Securisea, Inc.
 * No license is provided to any third parties.
 * If found outside of a Securisea, Inc. environment
 * report to bounty@securisea.com for a possible cash reward
 * and promptly delete all files.
 */
import React from "react";
import MFAManagement from "../sidebar/mfa";
import { User } from "../../types/users";

interface MFAEnrollmentProps {
  user: User;
  onEnrollmentComplete: () => void;
}

const MFAEnrollment: React.FC<MFAEnrollmentProps> = ({ user, onEnrollmentComplete }) => {
  return (
    <div style={{ 
      position: 'fixed', 
      top: 0, 
      left: 0, 
      right: 0, 
      bottom: 0, 
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      zIndex: 9999,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '8px',
        padding: '20px',
        maxWidth: '90vw',
        maxHeight: '90vh',
        overflow: 'auto'
      }}>
        <MFAManagement 
          user={user}
          mode="enrollment"
          onEnrollmentComplete={onEnrollmentComplete}
        />
      </div>
    </div>
  );
};

export default MFAEnrollment; 